import { render, staticRenderFns } from "./MenuHandout.vue?vue&type=template&id=110d4d15&scoped=true&"
import script from "./MenuHandout.vue?vue&type=script&lang=js&"
export * from "./MenuHandout.vue?vue&type=script&lang=js&"
import style0 from "./MenuHandout.vue?vue&type=style&index=0&id=110d4d15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110d4d15",
  null
  
)

export default component.exports